module.exports = __webpack_public_path__ + "static/media/profile_sm.e62a1b22.png";